import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';
import Hero from '../components/sections/Hero';
import Body from '../components/sections/Body';
import OptInModal from '../components/OptInModal';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    // Check if we have a section to scroll to from navigation
    if (location.state?.scrollTo) {
      scroller.scrollTo(location.state.scrollTo, {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: -70,
      });
    }
  }, [location]);

  return (
    <div>
      <Hero />
      <Body />
      <OptInModal
      />
    </div>
  );
};

export default Home;
